import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Select, Input, Modal, DatePicker, Space, Divider, Form } from "antd";
import { SearchOutlined, ArrowRightOutlined, CodeSandboxOutlined, EyeOutlined } from "@ant-design/icons";
import PageHeader from "../view/pageheader";
import { getDashboardList, getDashboardPreprcoessBox } from "../store/reducer/dashboardSlice";
import { useSelector, useDispatch } from "react-redux";
import TableComponent from "./CustomComponents/TableComponent";
import SearchComponent from "./CustomComponents/SearchComponent";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { getUserEventTaskList, getUserEventRecordHistoryList } from "../store/reducer/dashboardSlice";

import './dashboard.css'
const UserDashBoard = () => {
    const dispatch = useDispatch()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [eventFields, setEventFields] = useState([]);
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id')
    const { getUserEventTaskListData, getUserEventRecordHistoryListData } = useSelector((state) => state.dashboard)
    const { count: totalCount, data: tableData } = getUserEventTaskListData
    const { count: totalRecordCount, data: eventRecorData } = getUserEventRecordHistoryListData
   const role_id = localStorage.getItem("role_id")
    const [selectedSpecId, setSelectedSpecId] = useState(null);
    const [searchModal, setSearchModal] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchDate, setSearchDate] = useState(null);
    function getData(payload = {}) {
        dispatch(getUserEventTaskList({ id: user_id, ...payload }))
        dispatch(getUserEventRecordHistoryList({ id: user_id, ...payload }))
    }
    useEffect(() => {
        getData({})
    }, [])
    const handleSearch = () => {
        const payloadData = {
            query: searchText,
        };


        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        // getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');

    };

    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
        },
        {
            title: "Time",
            dataIndex: "time",
            key: "time",
        },
        {
            title: "Barcode",
            dataIndex: "barcode",
            key: "barcode",

        },
        {
            title: "Stage",
            dataIndex: "event_name",
            key: "event_name",
        },
        // {
        //     title: "User",
        //     dataIndex: "user_name",
        //     key: "user_name",
        // },
        // {
        //     title: "State",
        //     dataIndex: "stage_name",
        //     key: "stage_name",
        // },
        {
            title: "Events Recorded",
            key: "details",
            render: (_, record) => {
                let fields = [];
                try {
                    fields = JSON.parse(record.event_field_data || "[]");
                } catch (err) {
                    fields = [];
                }

                return (
                    <>
                        {/* Event History button */}
                        <Button
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => {
                                setEventFields(fields);
                                setIsModalOpen(true);
                            }}
                        >
                            View Events
                        </Button>

                        {/* Inline preview */}
                        <span style={{ marginLeft: 8 }}>
                            {fields.length > 0 ? (
                                fields.map((f, i) => (
                                    <span key={f.fieldId}>
                                        <strong>{f.fieldName}:</strong> {f.value || "-"}
                                        {i < fields.length - 1 && ", "}
                                    </span>
                                ))
                            ) : (
                                <span>-</span>
                            )}
                        </span>
                    </>
                );
            },
        },

    ];
    const data = [
        {
            key: '1',
            date: '8/21/2025',
            time: '03:41 AM',
            stage: 'Data Entry',
            user: 'Seth',
            state: 'Awaiting Review',
            event_recorded: (
                <div>
                    <Button
                        type="link"
                        icon={<EyeOutlined />}
                    // onClick={() => {
                    //   setEventFields([{ name: "Some event field" }]); // static fields
                    //   setIsModalOpen(true);
                    // }}
                    >
                        View Events
                    </Button>
                    <span style={{ marginLeft: 8 }}>
                        Spec: 22212, Box: 3, Alt Box: 2, Barcode: 222120003, Sample 12: sample
                    </span>
                </div>
            ),
        },
        {
            key: '2',
            date: '9/21/2025',
            time: '03:51 AM',
            stage: 'Data Entry',
            user: 'Mike',
            state: 'Awaiting Review',
            event_recorded: (
                <div>
                    <Button
                        type="link"
                        icon={<EyeOutlined />}
                    // onClick={() => {
                    //   setEventFields([{ name: "Some event field" }]);
                    //   setIsModalOpen(true);
                    // }}
                    >
                        View Events
                    </Button>
                    <span style={{ marginLeft: 8 }}>
                        Spec: 22212, Box: 3, Alt Box: 2, Barcode: 222120003, Sample 12: sample
                    </span>
                </div>
            ),
        },
    ];


    const boxColumns = [
        {
            title: 'Barcode',
            dataIndex: 'barcode',
            key: 'barocde'
        },
        {
            title: 'Spec ID ',
            dataIndex: 'spec',
            key: 'spec',
            align: 'center',
        },
        {
            title: 'Spec Box No',
            dataIndex: 'box',
            key: 'box',
            align: 'center',
        },
        {
            title: 'Stage',
            dataIndex: 'event_name',
            key: 'event_name',
            align: 'center',
        },

        {
            title: '	Pickup Date',
            dataIndex: 'pickup_date',
            key: 'pickup_date',
            align: 'center',

        },
        {
            title: 'Box State',
            dataIndex: 'box_state',
            key: 'box_state',
            align: 'center',
            render: (state) => {
                return <span>Production</span>
            }

        },
        {
            title: 'Process Box',
            key: 'action',
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    {/* <Button className="primary-btn rounded-4">View</Button> */}
                    <Button
                        onClick={() => {
                            navigate(`/jobs/job_event/${window.btoa(record.spec_id)}`, {
                                state: {
                                    job_name: window.btoa(record?.barcode_spec?.job_name),
                                    spec_id: record?.spec_id,
                                    job_barcode: record?.barcode,
                                    event_id: record?.event_id,
                                    // workflow_name: workflow_name,
                                    customer_id: window.btoa(record?.user_id),
                                    // workflow_id: workflow_id

                                }
                            })
                        }}
                        icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
                </Space>
            ),
        }
    ]
    const boxData = [
        {
            key: 1,
            barocde: 123450001,
            spec_id: 12345,
            spec_box_no: 2,
            stage: 'Prep',

            pickup_date: '08/05/2025',
            box_state: 'Awaiting Review	'

        },
        {
            key: 2,
            barocde: 123450002,
            spec_id: 12345,
            spec_box_no: 4,
            stage: 'Prep',

            pickup_date: '10/05/2025',
            box_state: 'Awaiting Review	'

        }

    ]

    return (
        <div>
            <PageHeader HeaderText="DashBoard" Breadcrumb={[{ name: "DashBoard" }]} backButtonUrl="" />
            {/* <Card title="">
            <Row gutter={16}>
               <Col style={{ marginTop: '20px' }} span={6}>
                  <Card styles={{ header: { color: 'white', borderBottom: "none" } }} style={{ color: 'white', background: 'linear-gradient(to right, rgb(153 56 68), rgb(244, 92, 67))' }} type="inner" size="small" title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <PiUserSquareBold size={18} />
                        Total Customers
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center"> {dashboardListData?.totalCustomersData}</p>
                  </Card>
               </Col>
               <Col style={{ marginTop: '20px', }} span={6}>
                  <Card styles={{ header: { color: 'white', borderBottom: "none" } }} style={{ background: 'linear-gradient(to right,  rgb(235, 51, 73), rgb(244, 92, 67)) ', color: 'white' }} type="inner" size="small" title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <FaUsersRectangle size={18} />
                        Total Production Users
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center"> {dashboardListData?.totalUserData}</p>
                  </Card>
               </Col>
               <Col style={{ marginTop: '20px' }} span={6}>
                  <Card styles={{ header: { color: 'white', borderBottom: "none" } }} type="inner" size="small" style={{ background: 'linear-gradient(to right,rgb(92 64 67), rgb(33 137 136))', color: 'white' }} title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <BiSolidUserAccount size={18} />
                        Total Specs
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center"> {dashboardListData?.totalJobsData}</p>
                  </Card>
               </Col>
               <Col style={{ marginTop: '20px' }} span={6}>
                  <Card styles={{ header: { color: 'white', borderBottom: "none" } }} style={{ background: 'linear-gradient(to right,rgb(218, 68, 83), rgb(137, 33, 107))', color: 'white' }} type="inner" size="small" title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <FaUsersCog size={18} />
                        Total In Progress Specs
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center">   {dashboardListData?.totalJobsData}</p>
                  </Card>
               </Col>
               <Divider />
               <Col span={6}>
                  <Card
                     style={{
                        background: "linear-gradient(to right, rgb(40, 48, 72), rgb(133, 147, 152))",
                        color: "white",
                     }}
                     styles={{ header: { color: "white", borderBottom: "none" } }}
                     size="small"
                     title={
                        <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                           <BsBoxes size={18} />
                           Total Boxes
                        </span>
                     }
                  >
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center">   {dashboardListData?.totalCustomersData}</p>
                  </Card>
               </Col>
               <Col span={6}>
                  <Card style={{
                     background: 'linear-gradient(45deg, rgb(212 0 182), rgb(43 46 46))',
                     color: 'white'

                  }}

                     styles={{ header: { color: 'white', borderBottom: "none" } }}
                     type="inner" size="small" title={
                        <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                           <BsFillInboxesFill size={18} />
                           Boxes In Production
                        </span>
                     }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center">  {dashboardListData?.totalJobsData}</p>
                  </Card>
               </Col>
               <Col span={6}>
                  <Card style={{ background: 'linear-gradient(45deg,rgb(34 111 9), rgb(84 83 82))', color: 'white' }} styles={{ header: { color: 'white', borderBottom: "none" } }} type="inner" size="small" title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <FaBoxesPacking size={18} />
                        Boxes Awaiting Review
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center">   {dashboardListData?.totalJobsData}</p>
                  </Card>
               </Col>
               <Col span={6}>
                  <Card styles={{ header: { color: 'white', borderBottom: "none" } }} style={{ background: 'linear-gradient(to right,rgb(230, 92, 0), rgb(249, 212, 35))', color: 'white' }} type="inner" size="small" title={
                     <span style={{ display: "flex", alignItems: "center", gap: "8px", color: "white" }}>
                        <FaBoxes size={18} />
                        Boxes Completed
                     </span>
                  }>
                     <p style={{ fontWeight: 900, fontSize: '19px' }} className="text-center">  {dashboardListData?.totalJobsData}</p>
                  </Card>
               </Col>

            </Row>
         </Card> */}

            <Card
                extra={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                            margin: "16px 0"
                        }}
                    >
                        {/* Left Side: Search + Buttons */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >
                            <span style={{ fontWeight: 900, fontSize: '20px', marginTop: '1px', marginRight: '250px' }}>My Tasks List</span>
                            <SearchComponent
                                style={{ width: "300px" }}
                                placeHolder="Search Spec ID or Customer Name"
                            />
                            <Button className="primary-btn rounded-4">
                                Search
                            </Button>

                        </div>

                        {/* Right Side: Search Filter Button */}
                        {/* <Button
                     className="primary-btn"
                     shape="round"
                     type="primary"
                     onClick={() => setSearchModal(true)}
                  >
                     Search Filter
                  </Button> */}

                        {/* Search Filter Modal */}
                        <Modal
                            open={searchModal}
                            onCancel={() => setSearchModal(false)}
                            onOk={handleSearch}
                            okText="Search"
                            title={
                                <span>
                                    Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                                    <hr />
                                </span>
                            }
                            width={600}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                {/* First Line: Spec */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Search by Spec
                                    </label>
                                    <Input
                                        placeholder="Enter Spec"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>

                                {/* Second Line: Pickup Date */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Pickup Date
                                    </label>
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        placeholder="Select Pickup Date"
                                        value={searchDate}
                                        onChange={(date) => setSearchDate(date)}
                                        format="MM/DD/YYYY"
                                    />
                                </div>

                                {/* Third Line: Event Stage */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Filter By Event Stage
                                    </label>
                                    <Select
                                        options={[
                                            { value: "Scan", label: "Scan" },
                                            { value: "Prep", label: "Prep" },
                                            { value: "OCR", label: "OCR" },
                                        ]}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                }
            >
                {/* <TableComponent columns={boxColumns} dataSource={boxData} size="small" /> */}
                <TableComponent columns={boxColumns} dataSource={tableData} size={"small"} TotalDataCount={totalCount} />

                <Divider />

            </Card>

            <Card
                extra={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "12px",
                            margin: "16px 0"
                        }}
                    >
                        {/* Left Side: Search + Buttons */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >
                            <span style={{ fontWeight: 900, fontSize: '20px', marginTop: '1px', marginRight: '250px' }}>Last Recorded Events</span>
                            <SearchComponent
                                style={{ width: "300px" }}
                                placeHolder="Search Spec ID or Customer Name"
                            />
                            <Button className="primary-btn rounded-4">
                                Search
                            </Button>

                            {/* <Button
                                className="primary-btn"
                                shape="round"
                                type="primary"
                                onClick={() => setSearchModal(true)}
                            >
                                Search Filter
                            </Button> */}
                        </div>

                        {/* Right Side: Search Filter Button */}


                        {/* Search Filter Modal */}
                        <Modal
                            open={searchModal}
                            onCancel={() => setSearchModal(false)}
                            onOk={handleSearch}
                            okText="Search"
                            title={
                                <span>
                                    Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                                    <hr />
                                </span>
                            }
                            width={600}
                        >
                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                {/* First Line: Spec */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Search by Spec
                                    </label>
                                    <Input
                                        placeholder="Enter Spec"
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                    />
                                </div>

                                {/* Second Line: Pickup Date */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Pickup Date
                                    </label>
                                    <DatePicker
                                        style={{ width: "100%" }}
                                        placeholder="Select Pickup Date"
                                        value={searchDate}
                                        onChange={(date) => setSearchDate(date)}
                                        format="MM/DD/YYYY"
                                    />
                                </div>

                                {/* Third Line: Event Stage */}
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ marginBottom: "6px", fontWeight: "bold" }}>
                                        Filter By Event Stage
                                    </label>
                                    <Select
                                        options={[
                                            { value: "Scan", label: "Scan" },
                                            { value: "Prep", label: "Prep" },
                                            { value: "OCR", label: "OCR" },
                                        ]}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                }
            >
                <TableComponent columns={columns} dataSource={eventRecorData} size="small" />

                <Divider />

            </Card>
            <Modal
                title="Event Details"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width={600}
            >
                <Form layout="vertical">
                    {eventFields.length > 0 ? (
                        eventFields.map((f) => (
                            <Form.Item key={f.fieldId} label={f.fieldName}>
                                <Input value={f.value || "-"} readOnly />
                            </Form.Item>
                        ))
                    ) : (
                        <p>No event details available</p>
                    )}
                </Form>
            </Modal>
        </div>
    );
};

export default UserDashBoard;
